import Vue from 'vue'
import Vuex from 'vuex'
import constantRoutes from "@/router/index";
const asyncRoutes= []

Vue.use(Vuex);

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
 function hasPermission(roles, route) {
    if (route.name) {
        return roles.some((role) => route.name === role || route.meta.auth);
    } else {
        return true;
    }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
 export function filterAsyncRoutes(routes, roles) {
    const res = [];
    routes.forEach((route) => {
        const tmp = { ...route };
        if (hasPermission(roles, tmp)) {
            if (tmp.children) {
                tmp.children = filterAsyncRoutes(tmp.children, roles);
            }
            res.push(tmp);
        }
    });

    return res;
}

const store = new Vuex.Store({
    state:{
        breadListState: [], // 面包屑列表数据
        name:'',
        visible:false,
        imgurl:'',
        visitedViews: [],
        cachedViews: [],
        routes: [],
        addRoutes: [],
        lineCount: 0
    },
    mutations: {
        setLineCount (state, count) {
            state.lineCount = count;
        },
        breadListMutations (getters, list) {
            getters.breadListState = list;
        },
        editName(state,data){
            state.name = data;
        },
        SetImg(state,data){
            this.state.visible=true
            this.state.imgurl=data
            console.log(this.state.visible);
            console.log(this.state.imgurl);
        },
        ADD_VISITED_VIEW: (state, view) => {
            if (state.visitedViews.some(v => v.path === view.path)) return
            state.visitedViews.push(
              Object.assign({}, view, {
                title: view.meta.title || 'no-name'
              })
            )
        },
        ADD_CACHED_VIEW: (state, view) => {
            if (state.cachedViews.includes(view.name)) return
            if (!view.meta.noCache) {
                state.cachedViews.push(view.name)
            }
        },
    
        DEL_VISITED_VIEW: (state, view) => {
            for (const [i, v] of state.visitedViews.entries()) {
                if (v.path === view.path) {
                state.visitedViews.splice(i, 1)
                break
                }
            }
        },
        DEL_CACHED_VIEW: (state, view) => {
            const index = state.cachedViews.indexOf(view.name)
            index > -1 && state.cachedViews.splice(index, 1)
        },
    
        DEL_OTHERS_VISITED_VIEWS: (state, view) => {
            state.visitedViews = state.visitedViews.filter(v => {
                return v.meta.affix || v.path === view.path
            })
        },
        DEL_OTHERS_CACHED_VIEWS: (state, view) => {
            const index = state.cachedViews.indexOf(view.name)
            if (index > -1) {
                state.cachedViews = state.cachedViews.slice(index, index + 1)
            } else {
                // if index = -1, there is no cached tags
                state.cachedViews = []
            }
        },
    
        DEL_ALL_VISITED_VIEWS: state => {
            // keep affix tags
            const affixTags = state.visitedViews.filter(tag => tag.meta.affix)
            state.visitedViews = affixTags
        },
        DEL_ALL_CACHED_VIEWS: state => {
            state.cachedViews = []
        },
        
        UPDATE_VISITED_VIEW: (state, view) => {
            for (let v of state.visitedViews) {
                if (v.path === view.path) {
                v = Object.assign(v, view)
                break
                }
            }
        },
        SET_ROUTES: (state, routes) => {
            state.addRoutes = routes;
            state.routes = constantRoutes.concat(routes);
        },
    },
    actions: {
        addView({ dispatch }, view) {
            dispatch('addVisitedView', view)
            dispatch('addCachedView', view)
          },
          addVisitedView({ commit }, view) {
            commit('ADD_VISITED_VIEW', view)
          },
          addCachedView({ commit }, view) {
            commit('ADD_CACHED_VIEW', view)
          },
        
          delView({ dispatch, state }, view) {
            return new Promise(resolve => {
              dispatch('delVisitedView', view)
              dispatch('delCachedView', view)
              resolve({
                visitedViews: [...state.visitedViews],
                cachedViews: [...state.cachedViews]
              })
            })
          },
          delVisitedView({ commit, state }, view) {
            return new Promise(resolve => {
              commit('DEL_VISITED_VIEW', view)
              resolve([...state.visitedViews])
            })
          },
          delCachedView({ commit, state }, view) {
            return new Promise(resolve => {
              commit('DEL_CACHED_VIEW', view)
              resolve([...state.cachedViews])
            })
          },
        
          delOthersViews({ dispatch, state }, view) {
            return new Promise(resolve => {
              dispatch('delOthersVisitedViews', view)
              dispatch('delOthersCachedViews', view)
              resolve({
                visitedViews: [...state.visitedViews],
                cachedViews: [...state.cachedViews]
              })
            })
          },
          delOthersVisitedViews({ commit, state }, view) {
            return new Promise(resolve => {
              commit('DEL_OTHERS_VISITED_VIEWS', view)
              resolve([...state.visitedViews])
            })
          },
          delOthersCachedViews({ commit, state }, view) {
            return new Promise(resolve => {
              commit('DEL_OTHERS_CACHED_VIEWS', view)
              resolve([...state.cachedViews])
            })
          },
        
          delAllViews({ dispatch, state }, view) {
            return new Promise(resolve => {
              dispatch('delAllVisitedViews', view)
              dispatch('delAllCachedViews', view)
              resolve({
                visitedViews: [...state.visitedViews],
                cachedViews: [...state.cachedViews]
              })
            })
          },
          delAllVisitedViews({ commit, state }) {
            return new Promise(resolve => {
              commit('DEL_ALL_VISITED_VIEWS')
              resolve([...state.visitedViews])
            })
          },
          delAllCachedViews({ commit, state }) {
            return new Promise(resolve => {
              commit('DEL_ALL_CACHED_VIEWS')
              resolve([...state.cachedViews])
            })
          },
        
          updateVisitedView({ commit }, view) {
            commit('UPDATE_VISITED_VIEW', view)
          },
          generateRoutes({ commit }, roles) {
            return new Promise((resolve) => {
                let accessedRoutes;
                // if (roles.includes("admin")) {
                //     accessedRoutes = asyncRoutes || [];
                // } else {
                //     accessedRoutes = filterAsyncRoutes(asyncRoutes, roles);
                // }
                accessedRoutes = filterAsyncRoutes(asyncRoutes, roles);
                commit("SET_ROUTES", accessedRoutes);
                resolve(accessedRoutes);
            });
        },
    }
})

export default store;